module.exports = __webpack_public_path__ + "img/selectIcon.7033680d.svg";